import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { defaultOnError } from "util/conditional/onError";
function getExternalActions() {
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.ContentUI.externalValueActions().url));
}
export default function useExternalActionsQuery({
  isLoadingSecurityLicense,
  isValidSecurityLicense
}) {
  const { isFetching, isError, data, error } = useQuery({
    queryKey: ["externalActions"],
    queryFn: () => defaultOnError(getExternalActions(), "Error fetching external actions"),
    enabled: !isLoadingSecurityLicense && isValidSecurityLicense
  });
  return {
    isFetching,
    isError,
    data,
    error
  };
}
